import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'tankFillPercentage'
})
export class TankFillPercentagePipe implements PipeTransform {

  transform(currentLiters: number, maxLiters: number): number {
    if (maxLiters === 0) {
      return 0;
    }
    const percentage = (currentLiters / maxLiters) * 100;
    return Math.round(percentage);
  }

}
